import { environment } from './../environments/environment';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
    {
        path: 'pagina-no-encontrada',
        loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule)
    },
    {
        path: 'preguntas-frecuentes',
        loadChildren: () => import('./faqs/faqs.module').then(m => m.FaqsModule)
    },
    {
        path: 'tarifas-de-entrenamiento',
        loadChildren: () => import('./prices/prices.module').then(m => m.PricesModule)
    },
    {
        path: 'tarifas-de-nutricion',
        loadChildren: () => import('./nutrition/nutrition.module').then(m => m.NutritionModule)
    },
    {
        path: 'instalaciones-centro-entrenamiento-personal',
        loadChildren: () => import('./facilities/facilities.module').then(m => m.FacilitiesModule)
    },
    {
        path: 'nosotros',
        loadChildren: () => import('./about/about.module').then(m => m.AboutModule)
    },
    {
        path: 'contacto',
        loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule)
    },
    {
        path: 'aviso-legal',
        loadChildren: () => import('./legal-advice/legal-advice.module').then(m => m.LegalAdviceModule)
    },
    {
        path: 'politica-de-privacidad',
        loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
    },
    {
        path: 'politica-de-cookies',
        loadChildren: () => import('./cookies-policy/cookies-policy.module').then(m => m.CookiesPolicyModule)
    },
    {
        path: '',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
    },
    {
        path: '**',
        redirectTo: 'pagina-no-encontrada',
        pathMatch: 'full'
    }
];

const enableTracing: boolean = environment.enableRoutingTracing;

@NgModule({
    exports: [ RouterModule ],
    imports: [ RouterModule.forRoot(routes, {enableTracing, scrollPositionRestoration: 'enabled'}) ],
})
export class AppRoutingModule {}
